import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {SharedModule} from "../../common/shared.module";
import {StartedRoutingModule} from "./started-routing.module";
import {StartedPickComponent} from './started-pick/started-pick.component';
import {StartedDownloadsComponent} from './started-downloads/started-downloads.component';
import {StartedTemplateComponent} from './started-template/started-template.component';
import {StartedCreateComponent} from './started-create/started-create.component';
import {StartedEntryComponent} from "./started-entry/started-entry.component";
import {NgxFlickingModule} from "@egjs/ngx-flicking";
import {TranslocoModule} from "@ngneat/transloco";
import {DialogAccountComponent} from "../../components/dialog-account/dialog-account.component";
import {OverviewModule, StartModule} from "..";

const directives = [];
const entryComponents = [
    StartedPickComponent,
    StartedDownloadsComponent,
    StartedTemplateComponent,
    StartedCreateComponent,
    StartedEntryComponent,
    DialogAccountComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        StartedRoutingModule,
        NgxFlickingModule,
        TranslocoModule,
        StartModule,
        OverviewModule
    ],
    declarations: [
        ...directives,
        ...entryComponents
    ],
    // entryComponents,
    exports: []
})
export class StartedModule {
}































